import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import Promise from 'bluebird';
import DeliveryAddress from './deliveryAddress';
import DeliveryTime from './deliveryTime';
import ShippingOptions from './shippingOptions';
import CustomerInfo from './customerInfo';
import PaymentMethod from './paymentMethod';
import Recommendations from '../recommendation';
import { getRecommendations, refreshShippingOptions } from '../cart/actions';
import {
  submit,
  setOrderId,
  resetDeliveryOptions,
  saveAddress,
  getGiftBag
} from './actions';
import { loadCards } from 'shared/components/payment/actions';
import { isEqual } from 'shared/models/address';
import { trackNow } from 'shared/models/analytic';
import { trackInfo } from 'shared/models/product';
import { getProducts } from 'shared/models/api';
import PaymentRequestButton from './paymentRequestButton';
import Button from 'shared/components/ui/button';
import LoadingSpinner from 'shared/components/ui/loadingSpinner';

let CheckoutForm = class CheckoutForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: this.firstEmptySection(props),
      userExists: !this.isEmpty('customerInfo'),
      loading: false,
      error: null,
      paymentRequestLoading: true,
      paymentRequestSelected: false
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handlePaymentRequestToken = this.handlePaymentRequestToken.bind(this);
  }

  componentDidMount() {
    this._trackStarted();
    this._checkForCollections();
    this.props.getRecommendations(this.props.skus);
  }

  componentWillReceiveProps(nextProps) {
    const userHasChanged =
      nextProps.user.objectId &&
      nextProps.user.objectId !== this.props.user.objectId;
    if (userHasChanged) {
      if (!nextProps.orderId) this.props.setOrderId();
      this.props.loadCards();
    }

    if (!isEqual(this.props.address, nextProps.address)) {
      this.props.resetDeliveryOptions();
      this.props.getGiftBag();
    }

    if (this.props.skus.join() !== nextProps.skus.join()) {
      if (nextProps.skus.length) this.props.getRecommendations(nextProps.skus);
      this.clearFormError();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.expanded !== prevState.expanded) {
      if (prevState.expanded) this._trackStepCompleted(prevProps, prevState);
      if (this.state.expanded) this._trackStepViewed(this.props, this.state);
    }
    if (this.props.cart.group_mapping !== prevProps.cart.group_mapping) {
      this._checkForCollections();
    }
  }

  _checkForCollections() {
    const group_mapping = this.props.cart.group_mapping;
    if (!group_mapping) return;
    const collectionSKUs = _.uniq(_.values(group_mapping));
    if (collectionSKUs.length) {
      getProducts(collectionSKUs).then(
        products => (this.collections = products)
      );
    }
  }

  _trackStarted() {
    let params = this._orderParams(this.props);
    params.logged_in = !!this.props.user.objectId;
    params.checkout_steps = this.state.userExists ? 3 : 4;
    params.address_completed =
      this.firstEmptySection(this.props) !== 'deliveryAddress';
    trackNow('Checkout Started', params);
  }

  _trackStepCompleted(props, state) {
    const params = this._stepParams(props, state);
    trackNow('Checkout Step Completed', params);
  }

  _trackStepViewed(props, state) {
    const params = this._stepParams(props, state);
    trackNow('Checkout Step Viewed', params);
  }

  _trackCompleted() {
    const params = this._orderParams(this.props, { revenue: true });
    trackNow('Order Completed', params);
    if (this.collections) this._trackCollectionsPurchased();
    window.branch.track('checkout', {
      order_id: this.props.id,
      parse_id: this.props.user.id || this.props.user.objectId
    });
    if (params.firstTimePurchaser) {
      trackNow('First Purchase');
      window.branch.track('First Purchase');
    }
  }

  _trackCollectionsPurchased() {
    const collections = this.collections || [];
    collections.forEach(collection => {
      const items = collection.ingredients
        .map(ingredient => {
          const cartItems = this.props.cart.products || [];
          return _.find(cartItems, item =>
            _.includes(ingredient.sku_list, item.sku_id)
          );
        })
        .filter(item => !!item);

      if (!items.length) return;

      trackNow('Collection Purchased', {
        title: collection.title,
        subtitle: collection.subtitle,
        volume: collection.volume,
        sku_id: collection.sku_id,
        price: items.reduce((total, item) => total + item.price, 0),
        items: items
      });
    });
  }

  _orderParams(props, opts = {}) {
    const vendor = props.vendor;
    const cart = props.cart;
    const promo = cart.promo;
    const shipping = props.address.shipping
      ? cart.shipping_fee
      : cart.delivery_fee;
    let params = {
      affiliation: vendor.store_id,
      subtotal: cart.subtotal,
      total: cart.total,
      order_id: props.id,
      shipping: shipping,
      tax: cart.tax,
      discount: promo && promo.value_type !== 'credit' ? promo.val : 0,
      coupon: promo && promo.value_type !== 'credit' ? promo.code : '',
      credit:
        promo && promo.value_type === 'credit' ? cart.total_discount : null,
      currency: 'USD',
      products: cart.products.map(item => {
        return trackInfo(item, item.qty);
      }),
      giftOrder: props.isGift
    };
    if (opts.revenue) {
      params.revenue = cart.total;
    }
    if (props.user && props.user.orders) {
      params.firstTimePurchaser = props.user.orders.length === 0;
    }
    return params;
  }

  _stepParams(props, state) {
    let step;
    let step_name;
    switch (state.expanded) {
      case 'deliveryAddress':
        step = 1;
        step_name = 'Delivery Address';
        break;
      case 'deliveryTime':
        step = 2;
        step_name = 'Delivery Time';
        break;
      case 'shippingOptions':
        step = 2;
        step_name = 'Shipping Options';
        break;
      case 'customerInfo':
        step = 3;
        step_name = 'Customer Info';
        break;
      case 'paymentMethod':
        step = this.state.userExists ? 3 : 4;
        step_name = 'Payment Method';
        break;
    }

    let params = {
      checkout_id: props.id,
      step,
      step_name
    };

    if (!_.isEmpty(props.paymentMethod))
      params.payment_method = props.paymentMethod.brand;
    if (!_.isEmpty(props.shippingOption))
      params.shipping_method = props.shippingOption.name;

    return params;
  }

  expand(section) {
    this.setState({ expanded: section });
  }

  collapse() {
    const nextExpanded = this.firstEmptySection(this.props);
    this.setState({ expanded: nextExpanded });
    return null;
  }

  firstEmptySection(props) {
    if (!props.cart.products.length) return null;

    const sections = [
      'deliveryAddress',
      props.address.shipping ? 'shippingOptions' : 'deliveryTime',
      'customerInfo',
      'paymentMethod'
    ];

    return _.find(sections, section => this.isEmpty(section)) || null;
  }

  isEmpty(section) {
    switch (section) {
      case 'deliveryAddress':
        return (
          _.isEmpty(this.props.address.address) ||
          _.isEmpty(this.props.address.zip)
        );
      case 'deliveryTime':
        return _.isEmpty(this.props.deliveryTime);
      case 'shippingOptions':
        return _.isEmpty(this.props.shippingOption);
      case 'customerInfo':
        return (
          _.isEmpty(this.props.user) ||
          _.isEmpty(this.props.user.firstname) ||
          _.isEmpty(this.props.user.lastname) ||
          _.isEmpty(this.props.user.birthday) ||
          _.isEmpty(this.props.user.email) ||
          _.isEmpty(this.props.user.mobile)
        );
      case 'paymentMethod':
        return _.isEmpty(this.props.paymentMethod);
      default:
        return false;
    }
  }

  canCheckOut() {
    return !this.state.expanded;
  }

  clearFormError() {
    this.setState({ error: null });
  }

  _validate() {
    const err = msg => Promise.reject(new Error(msg));

    if (this._isImmediateDelivery() && !this._isOpen()) {
      return err(
        "Saucey isn't accepting orders for immediate delivery right now."
      );
    }

    if (this._cartHasUnavailableProducts()) {
      return err(
        "Some of the items in your cart aren't available at this location. Please remove them before continuing."
      );
    }

    if (this._cartIsEmpty()) {
      return err('Your cart is empty.');
    }

    return Promise.resolve();
  }

  _isImmediateDelivery() {
    return !this.props.deliveryTime.start && !this.props.shippingOption;
  }

  _isOpen() {
    let vendor = this.props.vendor;
    let open = vendor.hours.open * 1000;
    let close = vendor.hours.close * 1000;
    let now = Date.now();
    return now >= open && now < close;
  }

  _cartHasUnavailableProducts() {
    return !!this.props.cart.products.filter(p => p.price == null).length;
  }

  _cartIsEmpty() {
    return !this.props.cart.products.filter(p => !!p.price).length;
  }

  _skus(products) {
    return products.filter(p => !!p.price).reduce(
      (skus, p) => ({
        ...skus,
        [p.sku_id]: p.qty
      }),
      {}
    );
  }

  handleSubmit(e) {
    e.preventDefault();
    return this._checkout(this.props.paymentMethod);
  }

  handlePaymentRequestToken(token, onSuccess, onFail) {
    return this._checkout({ token }, onSuccess, onFail);
  }

  _checkout(paymentMethod, onSuccess, onFail) {
    this.setState({ loading: true, error: null });

    return this._validate()
      .then(() => {
        let params = {
          skus: this._skus(this.props.cart.products),
          address: this.props.address,
          phone: this.props.user.mobile
        };

        if (paymentMethod.token) {
          params.stripeToken = paymentMethod.token;
        } else {
          params.cardId = paymentMethod.id;
        }

        if (this.props.deliveryTime.start)
          params.scheduled = this.props.deliveryTime.start;
        if (this.props.cart.promo) {
          if (this.props.cart.promo.value_type === 'credit') {
            params.credit = this.props.cart.promo;
          } else {
            params.promo = this.props.cart.promo.code;
          }
        }
        if (this.props.shippingOption)
          params.shipping_name = this.props.shippingOption.name;
        if (this.props.isGift)
          params.gift = {
            name: this.props.giftRecipient,
            phone: this.props.giftMobile,
            message: this.props.giftNote
          };

        return this.props.submit(params, onSuccess, onFail);
      })
      .then(() => this._trackCompleted())
      .then(() => this.props.saveAddress())
      .then(() => (window.location = '/tracking'))
      .catch(({ message }) =>
        this.setState({ loading: false, error: message })
      );
  }

  render() {
    const canCheckOut = this.canCheckOut();
    const showPaymentRequestButton =
      _.isEmpty(this.props.paymentMethod) ||
      this.props.paymentMethod.id === 'paymentRequest';

    return (
      <div className="checkout-form clearfix">
        <div className="vertical-rhythm">
          <CheckoutSection
            isExpanded={this.state.expanded === 'deliveryAddress'}
            canEdit={!this.isEmpty('deliveryAddress')}
            expand={() => this.expand('deliveryAddress')}
            collapse={() => this.collapse('deliveryAddress')}
            iconComponent={DeliveryAddress.Icon}
            expandedComponent={DeliveryAddress.Expanded}
            collapsedComponent={DeliveryAddress.Collapsed}
          />
          {this.props.address.shipping ? (
            <CheckoutSection
              isExpanded={this.state.expanded === 'shippingOptions'}
              canEdit={!this.isEmpty('shippingOptions')}
              expand={() => this.expand('shippingOptions')}
              collapse={() => this.collapse('shippingOptions')}
              iconComponent={ShippingOptions.Icon}
              expandedComponent={ShippingOptions.Expanded}
              collapsedComponent={ShippingOptions.Collapsed}
            />
          ) : (
            <CheckoutSection
              isExpanded={this.state.expanded === 'deliveryTime'}
              canEdit={!this.isEmpty('deliveryTime')}
              expand={() => this.expand('deliveryTime')}
              collapse={() => this.collapse('deliveryTime')}
              iconComponent={DeliveryTime.Icon}
              expandedComponent={DeliveryTime.Expanded}
              collapsedComponent={DeliveryTime.Collapsed}
            />
          )}
          {!this.state.userExists && (
            <CheckoutSection
              isExpanded={this.state.expanded === 'customerInfo'}
              canEdit={!this.isEmpty('customerInfo')}
              expand={() => this.expand('customerInfo')}
              collapse={() => this.collapse('customerInfo')}
              iconComponent={CustomerInfo.Icon}
              expandedComponent={CustomerInfo.Expanded}
              collapsedComponent={CustomerInfo.Collapsed}
            />
          )}
          <CheckoutSection
            isExpanded={this.state.expanded === 'paymentMethod'}
            canEdit={!this.isEmpty('paymentMethod')}
            expand={() => this.expand('paymentMethod')}
            collapse={() => this.collapse('paymentMethod')}
            iconComponent={PaymentMethod.Icon}
            expandedComponent={PaymentMethod.Expanded}
            collapsedComponent={PaymentMethod.Collapsed}
          />

          {!!this.props.recommendations.length && (
            <div className="checkout-section checkout-section--recommendations">
              <Recommendations
                thumbnail
                title={"Don't Forget to Add"}
                list={this.props.recommendations}
                onClick={this.props.openQuickView}
              />
            </div>
          )}
        </div>

        {this.state.error && (
          <div className="checkout-form__error warning warning--danger">
            {this.state.error}
          </div>
        )}

        {canCheckOut && (
          <form onSubmit={this.handleSubmit} className="checkout-form__submit">
            <p className="checkout-form__small">
              <small>
                Someone 21 years or older must be present upon delivery with a
                valid government issued ID.
              </small>
            </p>
            {!showPaymentRequestButton && (
              <Button
                type="submit"
                className="btn-primary green btn--full-width"
                disabled={
                  this.state.loading ||
                  this.props.loading ||
                  this.props.cart.loading
                }
                loading={
                  this.state.loading ||
                  this.props.loading ||
                  this.props.cart.loading
                }
              >
                Place Order
              </Button>
            )}
          </form>
        )}

        {showPaymentRequestButton && (
          <div className="checkout-form__submit">
            <PaymentRequestButton
              disabled={
                !canCheckOut ||
                this.state.loading ||
                this.props.loading ||
                this.props.cart.loading
              }
              onToken={this.handlePaymentRequestToken}
            />
            {(this.state.loading || this.props.loading) && (
                <LoadingSpinner green />
              )}
          </div>
        )}
      </div>
    );
  }
};

CheckoutForm = connect(
  state => ({
    ...state.checkout,
    address: state.address,
    user: state.login.user || {},
    cart: state.cart,
    skus: state.cart.products.map(p => p.sku_id),
    loadingRecommendations: state.cart.loadingRecommendations,
    recommendations: state.cart.recommendations || []
  }),
  {
    submit,
    setOrderId,
    resetDeliveryOptions,
    saveAddress,
    getRecommendations,
    refreshShippingOptions,
    getGiftBag,
    loadCards
  }
)(CheckoutForm);

const CheckoutSection = props => {
  const { isExpanded, expand, canEdit } = props;

  return (
    <section className="checkout-section">
      <div className="checkout-section__icon-container">
        <props.iconComponent />
      </div>
      {!isExpanded &&
        canEdit && (
          <button className="btn-small checkout-section__btn" onClick={expand}>
            Edit
          </button>
        )}
      {isExpanded ? (
        <props.expandedComponent collapse={props.collapse} />
      ) : (
        <props.collapsedComponent expand={expand} />
      )}
    </section>
  );
};

export default CheckoutForm;



// WEBPACK FOOTER //
// ./shared/components/checkoutPage/form.js